import { render, staticRenderFns } from "./WanXiang.vue?vue&type=template&id=64391124&scoped=true&"
import script from "./WanXiang.vue?vue&type=script&lang=js&"
export * from "./WanXiang.vue?vue&type=script&lang=js&"
import style0 from "./WanXiang.vue?vue&type=style&index=0&id=64391124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64391124",
  null
  
)

export default component.exports